import React from "react";
import svgUrl from "/opt/actions-runner/_work/v3-swap/v3-swap/src/assets/svg/celo_logo.svg?url";
const SvgCeloLogo = (props) => /* @__PURE__ */ React.createElement("svg", {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 250 250",
  style: {
    enableBackground: "new 0 0 250 250"
  },
  xmlSpace: "preserve",
  ...props
}, /* @__PURE__ */ React.createElement("style", {
  type: "text/css"
}, "\n	.st0{fill:#FCFF52;}\n"), /* @__PURE__ */ React.createElement("circle", {
  className: "st0",
  cx: 125,
  cy: 125,
  r: 125
}), /* @__PURE__ */ React.createElement("path", {
  d: "M188.9,60.7H60.7v128.2h128.2v-44.8h-21.3c-7.3,16.3-23.8,27.7-42.7,27.7c-26,0-47.1-21.3-47.1-47.1c0-25.9,21.1-47,47.1-47 c19.3,0,35.8,11.7,43.1,28.4h20.9V60.7z"
}));
export {SvgCeloLogo as ReactComponent};
export default svgUrl;
